import React, { useEffect, useRef } from 'react';
import ShippingOptions from '../components/shipping/ShippingOptions';
import ShippingInfo from '../components/shipping/ShippingInfo';
import { fadeIn } from '../utils/gsapAnimations';

function Shipping() {
  const pageRef = useRef(null);

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  return (
    <div ref={pageRef} className="bg-cream">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-lora font-semibold text-burgundy mb-6">Shipping</h1>
        <ShippingOptions />
        <ShippingInfo />
      </div>
    </div>
  );
}

export default Shipping;